var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full bg-white"},[_c('PurchaseOnboardModal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }